class Menu {

	constructor() {
		this.init();
    this.mobile();
		this.mobileSidebar();
	}

	init() {
		$(document).on({
      mouseenter: function() {
				$(this).css('position', 'inherit');

				var width = $(this).find('ul.dropdown-menu.depth_0').outerWidth();

        $(this).find('ul.dropdown-menu.depth_0').css('width', width + 'px');

				$(this).addClass('position-relative');
      },
      mouseleave: function() {

      }
    }, '#primary-menu > li.dropdown');

		$(document).on({
      mouseenter: function() {
        $(this).addClass('sub-menu-active');

        $(this).find('.dropdown-menu.sub-menu').css('top', '-' + $(this).position().top + 'px');

				let outerWidth = $(this).outerWidth(),
						minHeight = $(this).parent().height()

				$(this).find('.dropdown-menu.sub-menu').css({
					right: 'inherit',
					left: '0'
				});

				if ($(this).find('.dropdown-menu.sub-menu').length) {
          let elm = $(this).find('.dropdown-menu.sub-menu'),
							off = elm.offset(),
							l = off.left + outerWidth,
							w = elm.width(),
							docW = $('body').width();

          let isEntirelyVisible = (l + w <= docW);

          if (!isEntirelyVisible) {
						$(this).addClass('edge')

						$(this).find('.dropdown-menu.sub-menu').css({
		          right: $(this).outerWidth() + 'px',
		          'min-height': minHeight + 'px',
		          transition: '0.5s',
							left: 'auto'
		        });
          } else {
						$(this).removeClass('edge')

						$(this).find('.dropdown-menu.sub-menu').css({
		          left: $(this).outerWidth() + 'px',
		          'min-height': minHeight + 'px',
		          transition: '0.5s',
							right: 'auto'
		        });
          }
        }

        $(this).find('.dropdown-menu.sub-menu').addClass('open');

				$(this).css({
          width: $(this).outerWidth()+'px',
        });
      },
      mouseleave: function() {
        $(this).removeClass('sub-menu-active');
        $(this).find('.dropdown-menu.sub-menu').removeClass('open');

				if($(this).hasClass('edge')){
	        $(this).find('.dropdown-menu.sub-menu').css({
	          right: '0',
						left: 'auto',
	          transition: '0.5s'
	        });
				}else{
					$(this).find('.dropdown-menu.sub-menu').css({
	          left: '0',
	          transition: '0.5s'
	        });
				}
      }
    }, '#primary-menu > li > ul.dropdown-menu > li.dropdown-submenu');
  }

  mobile(){

		$(document).on('click', '#mobile-menu-expanded li.dropdown-submenu', function(e){
			if(!$(e.target).closest('a').length){
				let menu_title = $(this).find(">:first-child").clone(),
						menu = $(this).find("ul").html();

				$('#mobile-menu-expanded-second-lvl .menu-title').html(menu_title);
				$('#mobile-menu-expanded-second-lvl .mobile-menu-lvl').html(menu);
				$('#mobile-menu-expanded-first-lvl, #mobile-menu-expanded-second-lvl').toggleClass('d-none');
			}
		});

		$('#mobile-menu li.dropdown').on('click', function(e){
			if(!$(e.target).closest('a').length){
				let menu_title = $(this).find(">:first-child").clone(),
						menu = $(this).find("ul").html();

				$('#mobile-menu-expanded-first-lvl .menu-title').html(menu_title);
				$('#mobile-menu-expanded-first-lvl .mobile-menu-lvl').html(menu);
				$('#mobile-menu-expanded-first-lvl, #mobile-menu-expanded, #menu-upper-lvl, #mobile-menu-expanded-first-lvl').toggleClass('d-none');
			}
		});

		$(document).on('click', '#mobile-menu-expanded .menu-title', function(e){
			if($(this).parent().is('#mobile-menu-expanded-first-lvl')){
				$('#mobile-menu-expanded-first-lvl, #mobile-menu-expanded, #menu-upper-lvl').toggleClass('d-none');
			}else{
				$('#mobile-menu-expanded-first-lvl, #mobile-menu-expanded-second-lvl').toggleClass('d-none');
			}
		});

		$('.toggle-mobile-menu').on('click', function(){
			if($('.toggle-mobile-menu.opened').length){
				$('body.overflow-hidden').removeClass('overflow-hidden');
			}else{
				$('body:not(.overflow-hidden)').addClass('overflow-hidden');
			}

			$(this).toggleClass('opened');
			$('#mobile-navigation').toggleClass('hidden').toggleClass('show');
			$('.toggle-mobile-menu-open, .toggle-mobile-menu-close').toggleClass('d-none');

			$('#sidebar-menu-mobile').removeClass('open');
			$('#toggle-sidebar-menu-mobile span.open-sidebar').removeClass('d-none');
			$('#toggle-sidebar-menu-mobile span.close-sidebar').addClass('d-none');
		});
  }

	mobileSidebar() {
		$('#toggle-sidebar-menu-mobile').insertBefore($('#breadcrumbs'));

		if($('#sidebar-menu-mobile li.page_item_has_children.current_page_parent').length){
			$('#sidebar-menu-mobile header').css('display', 'block')
			$('#sidebar-menu-mobile li.page_item_has_children.current_page_ancestor').addClass('open')

			let menu_title = $('#sidebar-menu-mobile li.page_item_has_children.current_page_parent').find("> a").clone();

			$('#sidebar-menu-mobile header').html(menu_title);
		}

		$(document).on('click', '#toggle-sidebar-menu-mobile', function(e){
			$('#sidebar-menu-mobile').toggleClass('open');
			$('#toggle-sidebar-menu-mobile span').toggleClass('d-none');
			$('body').toggleClass('overflow-hidden');
		});

		$('#sidebar-menu-mobile li.page_item_has_children').on('click', function(e){
			if(!$(e.target).closest('a').length){
				$('#sidebar-menu-mobile header').css('display', 'block')
				$(this).addClass('open');

				let menu_title = $(e.target).find("> a").clone();

				$('#sidebar-menu-mobile header').html(menu_title);
			}
		});

		$('#sidebar-menu-mobile header').on('click', function(e){
			$('#sidebar-menu-mobile .page_item_has_children.open:last').removeClass('open')

			let last = $('#sidebar-menu-mobile .page_item_has_children.open:last > a').clone();

			if(last.length){
				$('#sidebar-menu-mobile header').html($('#sidebar-menu-mobile .page_item_has_children.open:last > a').clone())
			}else{
				$('#sidebar-menu-mobile header').css('display', 'none')
			}
		});
  }
}

export default Menu;
